// extracted by mini-css-extract-plugin
export default {"ProjectsContainer":"Project_ProjectsContainer__wv09V","ProjectHeading":"Project_ProjectHeading__7dp7n","Current":"Project_Current__rvhRT","ProjectsDiv":"Project_ProjectsDiv__KQCrf"};